import { TApplicationState } from '../../types/redux';
import { EFormStep } from '../../types/requestForm/requestFormV2';

export const selectFormStep = (state: TApplicationState): EFormStep => state.requestFormV2.step;
